/**
 * 解析 API 返回的 JSON 数组字段。
 * 兼容 Sequelize JSON 列被 seed 误用 JSON.stringify 导致的「双重编码」字符串。
 */
export function parseJsonArray(value, fallback = []) {
  if (value == null || value === '') return fallback;
  if (Array.isArray(value)) return value;

  let current = value;
  for (let i = 0; i < 3; i += 1) {
    if (Array.isArray(current)) return current;
    if (typeof current !== 'string') break;
    try {
      current = JSON.parse(current);
    } catch {
      return fallback;
    }
  }

  return Array.isArray(current) ? current : fallback;
}

export default parseJsonArray;
